<script setup>
const props = defineProps({ blok: Object })

const target = ref(null)
const targetIsVisible = ref(false)

const getWidth = ref(0)
const getHeight = ref(0)

function getSize(width, height) {
  getWidth.value = Math.ceil(width)
  getHeight.value = Math.ceil(height)
}

const paddingClasses = computed(() => {
  switch (props.blok.padding) {
    case 'padding-none':
      return 'py-0'
    case 'padding-top':
      return 'pt-mobile lg:pt-desktop'
    case 'padding-both':
      return 'py-mobile lg:py-desktop'
    default :
      return 'pb-mobile lg:pb-desktop'
  }
})

const { stop } = useIntersectionObserver(
  target,
  ([{ isIntersecting }], observerElement) => {
    if (isIntersecting)
      targetIsVisible.value = isIntersecting
  },
)

function filteredBlok() {
  props.blok.columns.forEach((element) => {
    return element.component
  })
}

onMounted(() => {
  if (filteredBlok() === 'model')
    filteredBlok()
})

const classes = computed(() => `${paddingClasses.value}`)
</script>

<template>
  <div

    class="relative" :class="[{ '!bg-primary py-mobile xl:py-[100px]': blok.darkmode || blok.graymode }, classes]"
  >
    <div v-if="blok.darkmode" class="absolute right-0 top-0 z-0 min-h-[200px] min-w-[200px] origin-center rotate-180 overflow-hidden 2xl:min-h-[550px] 2xl:min-w-[550px] lg:min-h-[450px] lg:min-w-[450px] sm:min-h-[250px] sm:min-w-[250px] -scale-x-100">
      <DecorlationRstriped current-color="text-secondary-red-100" class="absolute top-0 z-0 h-full w-auto origin-center translate-x-0 mix-blend-darken" />
    </div>
    <div
      v-editable="blok"
      :style="{
      }"
      class="relative flex items-center"
    >
      <div ref="target" class="container overflow-x-hidden">
        <div class="flex flex-col-reverse items-center gap-16 gap-y-custom-lg lg:flex-row" :class="blok.gap">
          <ContentGridLayout
            v-for="content in blok.columns"
            :key="content._uid"
            :is-visible="targetIsVisible"
            :reverse="blok.reverse"
            :darkmode="blok.darkmode"
            :blok="content"
            @get-size="getSize"
          />
        </div>
      </div>
    </div>
  </div>
</template>
